export const OG_IMAGE = '/brand-pages/impact/opengraph-impact.jpg';
